module.exports = ".icon-done {\n  color: green; }\n\n.error {\n  color: rgba(0, 0, 0, 0.26); }\n"